import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { Globe, Zap, Layers, MapPin, MessageSquare, Star, Menu, Download } from 'lucide-react';
import './LandingPage.css';

const APP_STORE_URL = 'https://apps.apple.com/tr/app/getspeakhub/id6771881202';
const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.getspeakhub.app&pcampaignid=web_share';

const AppleIcon: React.FC = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
    <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
  </svg>
);

const GooglePlayIcon: React.FC = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="#fff">
    <path d="m3.18 23.76 10.26-10.27-2.88-2.87L3.18 23.76zM20.1 10.46l-2.69-1.56-3.31 3.31 3.31 3.3 2.7-1.57c.77-.45.77-1.04-.01-1.48zM3.12.3C2.8.65 2.62 1.18 2.62 1.9v20.2c0 .71.18 1.25.5 1.59l.08.08L14.07 12.5v-.27L3.2.22.3.3zM13.44 9.44 3.18.24l7.38 13.42 2.88-4.22z" />
  </svg>
);

const SignalIcon: React.FC = () => (
  <svg width="14" height="10" viewBox="0 0 14 10" fill="#334155">
    <rect x="0" y="4" width="2" height="6" rx="1" />
    <rect x="3" y="2.5" width="2" height="7.5" rx="1" />
    <rect x="6" y="1" width="2" height="9" rx="1" />
    <rect x="9" y="0" width="2" height="10" rx="1" />
  </svg>
);

const PinIcon: React.FC = () => (
  <svg width="8" height="8" viewBox="0 0 24 24" fill="none" stroke="#94A3B8" strokeWidth="2.5" strokeLinecap="round">
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" />
    <circle cx="12" cy="10" r="3" />
  </svg>
);

const XIcon: React.FC = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.746l7.73-8.835L1.254 2.25H8.08l4.26 5.632 5.904-5.632zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </svg>
);

const InstagramIcon: React.FC = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
  </svg>
);

const LinkedInIcon: React.FC = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor">
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
  </svg>
);

const YouTubeIcon: React.FC = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor">
    <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
  </svg>
);

function useIntersectionObserver(threshold = 0.1) {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [threshold]);

  return { ref, visible };
}

const LandingPage: React.FC = () => {
  const [scrolled, setScrolled] = useState(false);

  const statsSection = useIntersectionObserver(0.1);
  const featuresSection = useIntersectionObserver(0.05);
  const howSection = useIntersectionObserver(0.05);
  const langsSection = useIntersectionObserver(0.05);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const languages = [
    'English', 'Spanish', 'French', 'German', 'Japanese', 'Korean',
    'Mandarin', 'Portuguese', 'Italian', 'Turkish', 'Arabic', 'Russian',
    'Hindi', 'Dutch', 'Swedish', 'Polish', 'Greek', '+ 33 more',
  ];

  return (
    <>
      {/* ── HEADER ── */}
      <header className={`lp-header${scrolled ? ' scrolled' : ''}`}>
        <div className="lp-container lp-hd">
          <a href="#hero" className="lp-hd-logo">
            <div className="lp-logo-mark">
              <div className="lp-logo-inner">
                <span className="lp-logo-g">G</span>
              </div>
            </div>
            <span className="lp-hd-logo-txt">GetSpeakHub</span>
          </a>

          <nav className="lp-nav">
            <a href="#features">Features</a>
            <a href="#how-it-works">How It Works</a>
            <a href="#languages">Languages</a>
          </nav>

          <div className="lp-hd-actions">
            <Link to="/auth/login" className="lp-hd-signin">Sign In</Link>
            <a href="#download" className="lp-hd-cta">Get Started</a>
          </div>

          <button className="lp-mobile-menu-btn" aria-label="Menu">
            <Menu width={22} height={22} />
          </button>
        </div>
      </header>

      {/* ── HERO ── */}
      <section className="lp-hero" id="hero">
        <div className="lp-hero-grid" />
        <div className="lp-container">
          <div className="lp-hero-inner">
            <div className="lp-hero-text">
              <div className="lp-hero-badge fu d1">
                <span className="lp-hero-badge-dot" />
                <span className="lp-hero-badge-txt">Now live in 100+ countries</span>
              </div>

              <h1 className="lp-hero-h fu d2">
                Find Your<br />Voice.<br />
                <span className="lp-hero-h-accent">Make Real<br />Friends.</span>
              </h1>

              <p className="lp-hero-sub fu d3">
                More than just an exchange. Discover real-time language meetups, join a table that matches your level, and find your people through meaningful conversations.
              </p>

              <div className="lp-hero-actions fu d4">
                <a href={APP_STORE_URL} target="_blank" rel="noopener noreferrer" className="lp-btn-store lp-btn-store-light">
                  <div className="lp-btn-store-icon">
                    <AppleIcon />
                  </div>
                  <div className="lp-btn-store-labels">
                    <span className="lp-btn-store-lbl-sm">Download on the</span>
                    <span className="lp-btn-store-lbl-lg">App Store</span>
                  </div>
                </a>
                <a href={PLAY_STORE_URL} target="_blank" rel="noopener noreferrer" className="lp-btn-store lp-btn-store-dark">
                  <div className="lp-btn-store-icon">
                    <GooglePlayIcon />
                  </div>
                  <div className="lp-btn-store-labels">
                    <span className="lp-btn-store-lbl-sm" style={{ color: 'rgba(255,255,255,.6)' }}>Get it on</span>
                    <span className="lp-btn-store-lbl-lg">Google Play</span>
                  </div>
                </a>
              </div>

              <div className="lp-hero-trust fu d5">
                <div className="lp-hero-trust-item">
                  <span className="lp-hero-trust-num" style={{ fontSize: '15px', letterSpacing: '.01em', lineHeight: '1.3' }}>Real-Time</span>
                  <span className="lp-hero-trust-lbl">Event Matching</span>
                </div>
                <div className="lp-hero-trust-div" />
                <div className="lp-hero-trust-item">
                  <span className="lp-hero-trust-num">50</span>
                  <span className="lp-hero-trust-lbl">Supported Languages</span>
                </div>
                <div className="lp-hero-trust-div" />
                <div className="lp-hero-trust-item">
                  <span className="lp-hero-trust-num">100+</span>
                  <span className="lp-hero-trust-lbl">Targeted Countries</span>
                </div>
              </div>
            </div>

            {/* Phone Mockup */}
            <div className="lp-hero-visual fu d3">
              <div className="lp-phone-wrap">
                <div className="lp-phone-glow" />
                <div className="lp-phone">
                  <div className="lp-phone-notch" />
                  <div className="lp-phone-screen">
                    <div className="lp-phone-status">
                      <span className="lp-p-time">9:41</span>
                      <div className="lp-p-icons">
                        <SignalIcon />
                        <div className="lp-p-bat" />
                      </div>
                    </div>
                    <div className="lp-phone-content">
                      <div className="lp-p-title">Discover Events</div>
                      <div className="lp-p-chips">
                        <span className="lp-p-chip lp-p-chip-on">All</span>
                        <span className="lp-p-chip lp-p-chip-off">English</span>
                        <span className="lp-p-chip lp-p-chip-off">Spanish</span>
                        <span className="lp-p-chip lp-p-chip-off">Turkish</span>
                      </div>

                      {/* Card 1 — LIVE */}
                      <div className="lp-p-card">
                        <div className="lp-p-card-row">
                          <div className="lp-p-date-block">
                            <div className="lp-p-date-month">MAY</div>
                            <div className="lp-p-date-day">24</div>
                            <div className="lp-p-date-time">09:30</div>
                          </div>
                          <div className="lp-p-card-info">
                            <div style={{ display: 'flex', alignItems: 'center', gap: '5px', marginBottom: '3px' }}>
                              <span className="lp-p-lang-pill">ENGLISH</span>
                              <span className="lp-p-live">
                                <span className="lp-p-live-dot" />
                                LIVE
                              </span>
                            </div>
                            <div className="lp-p-card-name">Morning Coffee &amp; Chat</div>
                            <div className="lp-p-card-loc">
                              <PinIcon />
                              Gezi Park, Istanbul
                            </div>
                          </div>
                        </div>
                        <div className="lp-p-host-row">
                          <div className="lp-p-host-avatar" />
                          <div className="lp-p-host-info">
                            <div className="lp-p-host-label">HOST</div>
                            <div className="lp-p-host-name">Daniel K.</div>
                          </div>
                          <span style={{ color: '#F59E0B', fontSize: '9px', fontWeight: 700 }}>★ 4.7</span>
                        </div>
                        <div className="lp-p-card-foot">
                          <span className="lp-p-joined">3/8 joined</span>
                          <span className="lp-p-spots">5 spots</span>
                        </div>
                        <div className="lp-p-progress">
                          <div className="lp-p-progress-fill" style={{ width: '37.5%' }} />
                        </div>
                      </div>

                      {/* Card 2 */}
                      <div className="lp-p-card">
                        <div className="lp-p-card-row">
                          <div className="lp-p-date-block">
                            <div className="lp-p-date-month">MAY</div>
                            <div className="lp-p-date-day">24</div>
                            <div className="lp-p-date-time">19:00</div>
                          </div>
                          <div className="lp-p-card-info">
                            <span className="lp-p-lang-pill lp-p-lang-pill-spanish">SPANISH</span>
                            <div className="lp-p-card-name" style={{ marginTop: '3px' }}>Spanish Intermediate Table</div>
                            <div className="lp-p-card-loc">
                              <PinIcon />
                              Cervantes, Kadıköy
                            </div>
                          </div>
                        </div>
                        <div className="lp-p-host-row">
                          <div className="lp-p-host-avatar lp-p-host-avatar-sofia" />
                          <div className="lp-p-host-info">
                            <div className="lp-p-host-label">HOST</div>
                            <div className="lp-p-host-name">Sofia R.</div>
                          </div>
                          <span className="lp-p-host-badge">✦ New</span>
                        </div>
                        <div className="lp-p-card-foot">
                          <span className="lp-p-joined">5/8 joined</span>
                          <span className="lp-p-spots">3 spots</span>
                        </div>
                        <div className="lp-p-progress">
                          <div className="lp-p-progress-fill" style={{ width: '62.5%' }} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── STATS ── */}
      <section className="lp-stats" ref={statsSection.ref}>
        <div className="lp-container lp-stats-inner">
          <div className={`lp-stat${statsSection.visible ? ' visible' : ''}`}>
            <div className="lp-stat-num">50</div>
            <div className="lp-stat-lbl">Supported Languages</div>
          </div>
          <div className={`lp-stat${statsSection.visible ? ' visible' : ''}`}>
            <div className="lp-stat-num">100+</div>
            <div className="lp-stat-lbl">Targeted Countries</div>
          </div>
        </div>
      </section>

      {/* ── FEATURES ── */}
      <section className="lp-features" id="features" ref={featuresSection.ref}>
        <div className="lp-container">
          <div className="lp-features-header">
            <div className="lp-section-label">
              <Zap width={13} height={13} /> Features
            </div>
            <h2 className="lp-section-heading" style={{ marginBottom: '16px' }}>
              Everything you need to<br />practice a language.
            </h2>
            <p className="lp-section-sub" style={{ margin: '0 auto' }}>
              From discovering local events to building a reputation, GetSpeakHub makes language practice social and meaningful.
            </p>
          </div>
          <div className="lp-features-grid">
            <div className={`lp-feat-card${featuresSection.visible ? ' visible' : ''}`}>
              <div className="lp-feat-icon"><MapPin width={28} height={28} /></div>
              <div className="lp-feat-title">Discover Local Events</div>
              <p className="lp-feat-desc">Find language exchange meetups near you on an interactive map or scrollable list. Filter by language, level, or date.</p>
            </div>
            <div className={`lp-feat-card${featuresSection.visible ? ' visible' : ''}`} style={{ transitionDelay: '.1s' }}>
              <div className="lp-feat-icon"><MessageSquare width={28} height={28} /></div>
              <div className="lp-feat-title">Join the Conversation</div>
              <p className="lp-feat-desc">Chat with hosts and participants before the event. Each table has its own group channel and direct messaging.</p>
            </div>
            <div className={`lp-feat-card${featuresSection.visible ? ' visible' : ''}`} style={{ transitionDelay: '.2s' }}>
              <div className="lp-feat-icon"><Star width={28} height={28} /></div>
              <div className="lp-feat-title">Build Your Reputation</div>
              <p className="lp-feat-desc">Earn reputation points by hosting and attending events. Your score is visible to the community, building trust.</p>
            </div>
          </div>
        </div>
      </section>

      {/* ── HOW IT WORKS ── */}
      <section className="lp-how" id="how-it-works" ref={howSection.ref}>
        <div className="lp-container">
          <div className="lp-how-header">
            <div className="lp-section-label">
              <Layers width={13} height={13} /> How It Works
            </div>
            <h2 className="lp-section-heading" style={{ marginBottom: '16px' }}>
              Three steps to your<br />first conversation.
            </h2>
            <p className="lp-section-sub" style={{ margin: '0 auto' }}>
              Getting started takes minutes. Speaking a new language takes courage. We make both easy.
            </p>
          </div>
          <div className="lp-how-steps">
            <div className="lp-how-line" />
            <div className={`lp-how-step${howSection.visible ? ' visible' : ''}`}>
              <div className="lp-how-num">1</div>
              <div className="lp-how-step-title">Create Your Account</div>
              <p className="lp-how-step-desc">Sign up with Google or email. Add your languages, level, and a photo. It takes two minutes.</p>
            </div>
            <div className={`lp-how-step${howSection.visible ? ' visible' : ''}`} style={{ transitionDelay: '.15s' }}>
              <div className="lp-how-num">2</div>
              <div className="lp-how-step-title">Find an Event Near You</div>
              <p className="lp-how-step-desc">Browse events by language or location. See who's hosting, how many spots remain, and when it starts.</p>
            </div>
            <div className={`lp-how-step${howSection.visible ? ' visible' : ''}`} style={{ transitionDelay: '.3s' }}>
              <div className="lp-how-num">3</div>
              <div className="lp-how-step-title">Show Up &amp; Speak</div>
              <p className="lp-how-step-desc">Join the table, practice with real people, and earn reputation points. Then host your own table.</p>
            </div>
          </div>
        </div>
      </section>

      {/* ── LANGUAGES ── */}
      <section className="lp-langs" id="languages" ref={langsSection.ref}>
        <div className="lp-container">
          <div className="lp-langs-header">
            <div className="lp-section-label">
              <Globe width={13} height={13} /> Languages
            </div>
            <h2 className="lp-section-heading" style={{ marginBottom: '14px' }}>
              50+ languages and counting.
            </h2>
            <p className="lp-section-sub" style={{ margin: '0 auto 0' }}>
              Our platform is built for global conversations. Choose your target language, join a table, and start practicing.
            </p>
          </div>
          <div className="lp-langs-grid">
            {languages.map((lang, i) => (
              <div
                key={lang}
                className={`lp-lang-chip${langsSection.visible ? ' visible' : ''}`}
                style={{ transitionDelay: `${i * 0.04}s` }}
              >
                <span className="lp-lang-dot" />
                {lang}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── DOWNLOAD CTA ── */}
      <section className="lp-download" id="download">
        <div className="lp-container">
          <div className="lp-download-inner">
            <div className="lp-section-label lp-download-label">
              <Download width={13} height={13} /> Download
            </div>
            <h2 className="lp-download-h">Start speaking today.</h2>
            <p className="lp-download-sub">Free to download. Free to join. Your next conversation is one tap away.</p>
            <div className="lp-download-actions">
              <a href={APP_STORE_URL} target="_blank" rel="noopener noreferrer" className="lp-btn-store lp-btn-store-light">
                <div className="lp-btn-store-icon">
                  <AppleIcon />
                </div>
                <div className="lp-btn-store-labels">
                  <span className="lp-btn-store-lbl-sm">Download on the</span>
                  <span className="lp-btn-store-lbl-lg">App Store</span>
                </div>
              </a>
              <a href={PLAY_STORE_URL} target="_blank" rel="noopener noreferrer" className="lp-btn-store lp-btn-store-dark">
                <div className="lp-btn-store-icon">
                  <GooglePlayIcon />
                </div>
                <div className="lp-btn-store-labels">
                  <span className="lp-btn-store-lbl-sm" style={{ color: 'rgba(255,255,255,.6)' }}>Get it on</span>
                  <span className="lp-btn-store-lbl-lg">Google Play</span>
                </div>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* ── FOOTER ── */}
      <footer className="lp-footer">
        <div className="lp-container">
          <div className="lp-footer-top">
            <div className="lp-footer-brand">
              <div className="lp-footer-brand-logo">
                <div className="lp-logo-mark">
                  <div className="lp-logo-inner">
                    <span className="lp-logo-g">G</span>
                  </div>
                </div>
                <span className="lp-footer-brand-name">GetSpeakHub</span>
              </div>
              <p className="lp-footer-desc">A community for language learners to practice real conversations at real events.</p>
            </div>

            <div>
              <div className="lp-footer-col-title">Product</div>
              <ul className="lp-footer-links">
                <li><a href="#features">Features</a></li>
                <li><a href="#how-it-works">How It Works</a></li>
                <li><a href="#languages">Languages</a></li>
                <li><a href="#download">Download</a></li>
              </ul>
            </div>

            <div>
              <div className="lp-footer-col-title">Company</div>
              <ul className="lp-footer-links">
                <li><a href="/about">About Us</a></li>
                <li><a href="#">Blog</a></li>
                <li><a href="/careers">Careers</a></li>
                <li><a href="#">Press</a></li>
              </ul>
            </div>

            <div>
              <div className="lp-footer-col-title">Legal</div>
              <ul className="lp-footer-links">
                <li><Link to="/terms">Terms of Use</Link></li>
                <li><Link to="/privacy">Privacy Policy</Link></li>
                <li><Link to="/community">Community Guidelines</Link></li>
                <li><Link to="/cookies">Cookie Policy</Link></li>
              </ul>
            </div>
          </div>

          <div className="lp-footer-bottom">
            <p className="lp-footer-copy">© 2026 GetSpeakHub, Inc. All rights reserved.</p>
            <div className="lp-footer-social">
              <a href="#" className="lp-social-btn" aria-label="X">
                <XIcon />
              </a>
              <a href="#" className="lp-social-btn" aria-label="Instagram">
                <InstagramIcon />
              </a>
              <a href="#" className="lp-social-btn" aria-label="LinkedIn">
                <LinkedInIcon />
              </a>
              <a href="#" className="lp-social-btn" aria-label="YouTube">
                <YouTubeIcon />
              </a>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default LandingPage;
